import { useAuth } from "./auth/AuthProvider";
import { AppShell } from "./components/AppShell";
import { ActivityPage } from "./pages/ActivityPage";
import { DashboardPage } from "./pages/DashboardPage";
import { LeadsPage } from "./pages/LeadsPage";
import { LocalesPage } from "./pages/LocalesPage";
import { LoginPage } from "./pages/LoginPage";
import { MarketingPage } from "./pages/MarketingPage";
import { MediaPage } from "./pages/MediaPage";
import { PageEditorPage } from "./pages/PageEditorPage";
import { PagesPage } from "./pages/PagesPage";
import { SettingsPage } from "./pages/SettingsPage";
import { TeamPage } from "./pages/TeamPage";
import { Navigate, Outlet, Route, Routes, useLocation } from "./router";

function ProtectedLayout() {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="app-boot">
        <span />
        <strong>Unicore Command Center</strong>
      </div>
    );
  }
  if (!user)
    return <Navigate replace state={{ from: location.pathname }} to="/login" />;
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}

export function App() {
  return (
    <Routes>
      <Route element={<LoginPage />} path="/login" />
      <Route element={<ProtectedLayout />}>
        <Route element={<DashboardPage />} index />
        <Route element={<PagesPage />} path="pages" />
        <Route element={<PageEditorPage />} path="pages/:pageId" />
        <Route element={<LocalesPage />} path="locales" />
        <Route element={<MediaPage />} path="media" />
        <Route element={<SettingsPage />} path="settings" />
        <Route element={<MarketingPage />} path="analytics" />
        <Route element={<LeadsPage />} path="leads" />
        <Route element={<TeamPage />} path="team" />
        <Route element={<ActivityPage />} path="activity" />
      </Route>
      <Route element={<Navigate replace to="/" />} path="*" />
    </Routes>
  );
}
